import { render, staticRenderFns } from "./AssignGroupConsumers.vue?vue&type=template&id=05b92e9b&"
import script from "./AssignGroupConsumers.vue?vue&type=script&lang=js&"
export * from "./AssignGroupConsumers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VCheckbox,VDialog})
